export default "__VITE_ASSET___BY6TrVH__"